import { useStore } from "@state/store"
import { useEffect, useState, Fragment } from "react"
import { createPortal } from "react-dom"
import styled from "styled-components/macro"
import { useProjectDataStore } from "@state/projectDataStore"
import First from "./components/First"
import Popup from "@common/components/Popup"

const Info1 = (props: any) => {
  const syncState = useStore((s) => s.syncState)
  const { info1Data } = useProjectDataStore((s) => ({
    info1Data: s.info1Data,
  }))
  const [src, setSrc] = useState(null)
  const [popUp, setPopup] = useState(null)
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null)
  const contentControls = useStore((s) => s.contentControls)

  function handleImageClick(obj) {
    setSrc(obj.img.publicURL)
    setPopup(true)
  }

  useEffect(() => {
    syncState({
      contentControls: {
        index: 0,
      },
    })
  }, [])

  useEffect(() => {
    const portalTarget = document.getElementById("root")
    if (!portalTarget) return
    setPortalTarget(portalTarget)
  }, [])

  return (
    <Fragment>
      <Info1Wrapper>
        <First
          info1Data={info1Data?.sections[0]}
          imageClick={handleImageClick}
        />
      </Info1Wrapper>
      {portalTarget &&
        createPortal(
          <Popup openState={popUp} setOpenState={setPopup} durationMS={600}>
            {src && (
              <FullScreenImage src={src} onClick={() => setPopup(false)} />
            )}
          </Popup>,
          portalTarget,
        )}
    </Fragment>
  )
}

export default Info1

const Info1Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--primary);
  display: flex;
`

const FullScreenImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: var(--primary);
  cursor: pointer;
`
